export default __webpack_public_path__ + "71f3b6758046f61f98d326bc6db8a9fb.jpg";